import React from 'react';
import BackButton from '../_Shared/BackButton';




function FrozenCapital() {
    return (
        <div className="container">
            <div className="jumbotron">
                <div className="col-sm-10 mx-auto">
                    <BackButton /><h2 className="text-center">Frozen Capital</h2>
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <div className="card text-white rounded formula-definition">
                                <div className="card-header text-center" id="formula">Formula Definition: Cash tied up in aged and/or excess receivables and inventories (any excess over 30 days’ supply of receivables + 60 days’ supply of inventory).
                                    <br /><br />
                                    ATD Guide: 0
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}




export {
    FrozenCapital
}